import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

class CompraDiretaApiClient {

    async buscarComprasDiretasPublicas(filtros, paginacao){
        return await axios.get('/compra-direta/api/public/v1/compras-diretas/?'+
            ParamUtils.ObjectsToParams([paginacao, filtros])
        )
    }

    async buscarComprasDiretasPublicasPorId(compraDiretaId){
        return await axios.get(`/compra-direta/api/public/v1/comprador/compras-diretas/${compraDiretaId}`)
    }

    async baixarAtaPublica(compraDiretaId) {
        return await axios.get(`/compra-direta/api/public/v1/compras-diretas/${compraDiretaId}/ata`,
            {
                responseType: 'arraybuffer'
            })
    }

    async buscarItensELotes(compraDiretaId){
        return await axios.get(`/compra-direta/api/public/v1/comprador/compras-diretas/${compraDiretaId}/itens`)
    }

    async buscarDocumentosSolicitados(compraDiretaId) {
        return await axios.get(`/compra-direta/api/public/v1/comprador/compras-diretas/${compraDiretaId}/documentos-solicitados`)
    }

    async buscarPorNivelProposta() {
        return await axios.get('/compra-direta/api/public/v1/configuracao/documentos/por-nivel/PROPOSTA')
    }

    async buscarDaCompraDireta(compraDiretaId) {
        return await axios.get(`/compra-direta/api/public/v1/comprador/compras-diretas/${compraDiretaId}/linhas-fornecimento`)
    }

    async buscarResumoProposta(compraDiretaId, propostaId) {
        const params = {}

        if (propostaId != null) {
            params.propostaId = propostaId
        }
        return await axios.get(`/compra-direta/api/public/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/resumo-compra-direta`,
            { params })
    }

    async buscarResultadoLotesItens(compraDiretaId) {
        return await axios.get(`/compra-direta/api/public/v1/fornecedor/compras-diretas/${compraDiretaId}/resultado/todos`)

    }

    async buscarDetalhes(compraDiretaId) {
        return await axios.get(`/compra-direta/api/public/v1/fornecedor/compras-diretas/${compraDiretaId}/detalhes`)
    }

}

export default new CompraDiretaApiClient()
